import React from 'react';

import { ProductButtonProps } from '../..';
import { BatchTicketButton } from '../../components/BatchTicketButton';

export const DirectTreasuryButton: React.FC<ProductButtonProps<'directTreasury'>> = (props) => {
  return <BatchTicketButton {...props} idSelector="productId" />;
};
